import { createFileRoute, Outlet } from "@tanstack/react-router";

// Integrations (#638 landed the nav/route placeholder; #646 is the connect-an-
// account surface itself — X, LinkedIn, dev.to, Bluesky, Mastodon —
// ported from `goodsender-web-v2@d9c2986`, with real per-workspace
// connection state (Medium dropped, #684: its API stopped issuing new
// integration tokens in 2026; Hashnode retired, see `catalog.ts`).
//
// A layout route, the same pattern as `subscribers.tsx`, so the built-in
// newsletter's settings can live UNDER the page that lists it:
// `integrations/index.tsx` renders the list, `integrations/newsletter.tsx` the
// newsletter's sender identity. The Integrations nav entry has no `exact`, so
// `AppLink`'s prefix match keeps the row current while the newsletter settings
// are open.
//
// Not flag-gated any more. #719 deferred social syndication behind the
// default-OFF `integrationsEnabled` flag and redirected this route away while it
// was off; the page now also carries the newsletter, which ships in every
// environment, so the route always renders and the FLAG narrows what the page
// lists (`IntegrationsPage` drops the third-party rows). The server-side
// boundary for those rows is unchanged: `checkIntegrationsEnabled`, chained on
// every third-party procedure.
export const Route = createFileRoute("/dashboard/w/$workspaceId/integrations")({
  component: Outlet,
});
